export const ADD_TO_CART_REQUEST_SUCCESS = "ADD_TO_CART_REQUEST_SUCCESS";
export const ADD_TO_CART_REQUEST_SERVER_ERROR = "ADD_TO_CART_REQUEST_SERVER_ERROR";
export const ADD_TO_CART_REQUEST_RESET = "ADD_TO_CART_REQUEST_RESET";

export const REMOVE_FROM_CART_SUCCESS = "REMOVE_FROM_CART_SUCCESS";
export const REMOVE_FROM_CART_ERROR = "REMOVE_FROM_CART_ERROR";

export const ADD_TO_CART_REQUEST_SUCCESS_MSG = "این محصول با موفقیت به سبد شما اضافه شد.";
export const REMOVE_FROM_CART_SUCCESS_MSG = "این محصول با موفقیت از سبد خرید شما حذف شد.";
export const ADD_TO_CART_REQUEST_SERVER_ERROR_MSG = "خطا هنگام درج به سبد، در فرصتی دیگر امتحان فرمایید."
export const REMOVE_FROM_CART_ERROR_MSG = "خطا در هنگام حذف آیتم از سبد خرید"

// export const ADD_TO_CART_REQUEST_BACKEND_ERROR = "ADD_TO_CART_REQUEST_BACKEND_ERROR";
// export const REQUEST_BACKEND_ERROR_MSG = "خطا در دریافت اطلاعات از سرور";
